// extracted by mini-css-extract-plugin
export default {"stats":"Dashboard_stats__-uENI","contentGrid":"Dashboard_contentGrid__fmnlM","bottomGrid":"Dashboard_bottomGrid__gtOoZ"};